// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2019-09-17 18:03:19 +0200 (Tue, 17 Sep 2019) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 103787 $
//  Purpose   : react hooks for tree component
// =============================================================================
// ---Third-party imports

// ---Framework imports
import {Sel} from 'uix/registries'
import {size, get, has} from 'ldash'
import log from 'uix/logging'

// ---Local imports
import {useSelector, useActions, useEffect} from 'uix/hooks'
import {getUserData} from './actions'
// ---Exports

export const useUserData = puid => {
  let users = useSelector(root => root.data.users)
  let actions = useActions({getUserData})
  useEffect(() => {
    if (puid && !has(users, puid)) {
      actions.getUserData({puid})
    }
  }, [actions])

  return users[puid]
}
